import React from "react"
import axios from "axios"
import { toast } from "react-toastify"
import * as Yup from "yup"
import Form from "../Common/Form/Form"

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Your name is required"),
  email: Yup.string()
    .email("Invalid e-mail address.")
    .required("E-mail is required"),
  subject: Yup.string().required("Subject is required."),
  message: Yup.string().required("Message is required."),
  terms: Yup.boolean()
    .required("The terms and conditions must be accepted.")
    .oneOf([true], "The terms and conditions must be accepted."),
})

const ContactForm = () => (
  <Form
    onSubmit={async (values, resetForm) => {
      let { message, subject, email, name } = values
      try {
        let response = await axios.post(
          process.env.GATSBY_API_URL + "/forms/create/contact-form",
          {
            message,
            subject: `${subject} ${name}`,
            email,
          }
        )

        if (response.status === 200) {
          toast.success("Message sent")
          resetForm()
        }
      } catch {
        console.log("error")
        toast.error("Unable to send message")
      }
    }}
    validationSchema={validationSchema}
    initialValues={{
      name: "",
      email: "",
      subject: "",
      message: "",
      terms: false,
    }}
    fields={[
      {
        placeholder: "Your Name",
        label: "Name",
        type: "input",
        name: "name",
      },
      {
        placeholder: "example@mail.com",
        label: "E-mail",
        type: "email",
        name: "email",
      },
      {
        placeholder: "Subject",
        label: "Subject",
        type: "input",
        name: "subject",
      },
      {
        placeholder: "Your Message...",
        label: "Message",
        type: "textarea",
        name: "message",
      },
      {
        label: "I agree with Terms and Conditions",
        type: "checkbox",
        name: "terms",
        to: "/terms",
      },
    ]}
    submitButtonText={"Send"}
    submitButtonStyle={{
      maxWidth: "fit-content",
    }}
  />
)

export default ContactForm
